import { withStyles } from "@material-ui/styles";
import cx from "classnames";
const styles = theme => ({
  container: {
    marginBottom: "40px"
  },
  heading: {
    ...theme.typography.secondaryFont,
    fontSize: "19px",
    lineHeight: "32px",
    color: "#414B5D",
    margin: "0 0 20px 0",
    textAlign: "center",
    ["@media (min-width:576px)"]: {
      fontSize: "23px",
      lineHeight: "32px",
      marginBottom: "16px"
    }
  },
  linksCnt: {
    display: "grid",
    "grid-template-columns": "1fr 1fr 1fr",
    justifyItems: "center",
    ["@media (max-width:576px)"]: {
      "& div:nth-child(3n + 1)": {
        borderLeft: "none"
      }
    },
    ["@media (min-width:576px)"]: {
      "grid-template-columns": "1fr 1fr 1fr 1fr 1fr",
      "& div:nth-child(5n + 1)": {
        borderLeft: "none"
      }
    }
  },
  subLinkCnt: {
    display: "grid",
    "grid-template-columns": "1fr",
    "grid-row-gap": "8px"
  },
  link: {
    ...theme.typography.defaultFont,
    borderLeft: "1px solid #F1F5F9",
    fontSize: "12px",
    lineHeight: "30px",
    fontWeight: 600,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    maxWidth: "100%",
    textAlign: "center",
    ["@media (min-width:576px)"]: {
      fontSize: "14px"
    },
    "& a": {
      textDecoration: "none",
      cursor: "pointer",
      color: "#414B5D"
    }
  },
  subHeading: {
    fontWeight: 700,
    margin: "0 0 8px 0",
    color: "#7C8BA2",
    textDecorationLine: "none"
  }
});
const RenderSitemapLinks = props => {
  const {
    data = {},
    classes,
    showHeading = true,
    anchorDisplayKey = "placeHolder",
    anchorTitleKey = "placeHolder"
  } = props;
  const { result = [], H2: heading = "" } = data;
  let containsPlaceholder = false;
  let dataArr = [];
  result.forEach(item => {
    if (!item.anchorPlaceHolder) {
      dataArr = Array.isArray(item?.links) ? item?.links : [];
    } else {
      dataArr.push(item);
      containsPlaceholder = true;
    }
  });

  // const onLinkClick = (heading, itemObj) => {
  //   const eventInfo = {
  //     linkName: itemObj?.[anchorDisplayKey],
  //     link: itemObj.url,
  //     heading
  //   };
  //   LogService.logEvents(PUBLIC_SITEMAP_LINK_CLICKED, eventInfo);
  // };

  return (
    <div className={classes.container}>
      {showHeading ? <h2 className={classes.heading}>{heading}</h2> : null}
      <div className={classes.linksCnt}>
        {!containsPlaceholder
          ? dataArr.map((item, index) => (
              <div key={`links${index}`} className={classes.link}>
                <a
                  href={item?.url}
                  target="_blank"
                  // onClick={e => onLinkClick(heading, item)}
                  title={item?.[anchorTitleKey]}
                >
                  {item?.[anchorDisplayKey]}
                </a>
              </div>
            ))
          : dataArr.map((item, index) => (
              <div key={`subHeading${index}`}>
                <h3 className={cx(classes.subHeading, classes.link)}>
                  {item?.anchorPlaceHolder}
                </h3>
                <div className={classes.subLinkCnt}>
                  {item?.links.map((subLink, index) => (
                    <div key={`subLinks${index}`} className={classes.link}>
                      <a
                        href={subLink?.url}
                        target="_blank"
                        // onClick={e => onLinkClick(heading, subLink)}
                      >
                        {subLink?.[anchorDisplayKey]}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};
export default withStyles(styles)(RenderSitemapLinks);
